/**
 * @generated SignedSource<<638fbe102d651ca63916079f4ec04ccb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NativeIssueTableWithSelectedIssuesProvider$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ColumnConfigWithContainer" | "IssueTableIssueTable">;
  readonly " $fragmentType": "NativeIssueTableWithSelectedIssuesProvider";
};
export type NativeIssueTableWithSelectedIssuesProvider$key = {
  readonly " $data"?: NativeIssueTableWithSelectedIssuesProvider$data;
  readonly " $fragmentSpreads": FragmentRefs<"NativeIssueTableWithSelectedIssuesProvider">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NativeIssueTableWithSelectedIssuesProvider",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ColumnConfigWithContainer"
    },
    {
      "kind": "FragmentSpread",
      "name": "IssueTableIssueTable"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "dc0bdf3d2319546b6ccb108b65845de6";

export default node;
